import { injectable } from 'inversify';
import type { ErrorMonitoringService } from '@kiplin/web-common/error-monitoring';

@injectable()
export class DeferredErrorMonitoringService implements ErrorMonitoringService {
  private readonly pendingErrors: Parameters<ErrorMonitoringService['captureException']>[] = [];
  private delegate?: ErrorMonitoringService;

  public captureException(...params: Parameters<ErrorMonitoringService['captureException']>): void {
    if (this.delegate) {
      this.delegate.captureException(...params);
      return;
    }

    // Bound memory usage if the SDK cannot be downloaded.
    if (this.pendingErrors.length === 100) this.pendingErrors.shift();
    this.pendingErrors.push(params);
  }

  public setDelegate(delegate: ErrorMonitoringService): void {
    this.delegate = delegate;
    this.pendingErrors.splice(0).forEach((params) => delegate.captureException(...params));
  }
}
